import visited from './visited'
import search from './search'
export default {
    ...visited,
    ...search
}
